import React from 'react';

export const SuccessCircleIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="#22C55E"/>
            <path d="M15.3337 6L8.00033 13.3333L4.66699 10" stroke="#DCFCE8" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}